import { useEditorStore } from '@/features/editor/stores/mobx/editor-store';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { NumberField } from '@/components/number-field/number-field';
import { FormattedMessage } from 'react-intl';

export const EsdecParapetHeightInput = observer(function EsdecParapetHeightInput({
  surfaceId
}: {
  surfaceId: string;
}) {
  const store = useEditorStore();
  const { surfacesEsdec } = store;

  const surfaceEsdec = surfacesEsdec.surfaces[surfaceId];

  if (!surfaceEsdec) {
    return <React.Fragment />;
  }

  return (
    <NumberField
      isDisabled={surfaceEsdec.isRoofFinalized}
      minValue={0}
      label={<FormattedMessage defaultMessage="Parapet Height" id="xEUEyO" />}
      formatOptions={{
        style: 'unit',
        unit: 'millimeter'
      }}
      showStepper={true}
      value={surfaceEsdec.parapetHeight}
      onChange={(value) => {
        if (Number.isNaN(value)) {
          return;
        }
        surfaceEsdec.updateParapetHeight(value);
      }}
    />
  );
});
